var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters flex-nowrap"},[_c('side-bar'),_c('main-panel',{staticClass:"col"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }